import React from 'react';
import style from '../AdditionalText/AdditionalText.module.css';

export default function AdditionalText() {
  return (
    <>
      <p className={style.additionalText}>Имя Фамилия</p>
    </>
  );
}
